export const STOCK_ITEM_STATUSES = ['AVAILABLE', 'INACTIVE'];
export const SHOP_STATUSES = ['ACTIVE', 'INACTIVE'];
export const LOCATION_TYPES = ['WAREHOUSE', 'SHOP', 'EVENT', 'CONSIGN_HOLD'];
/**
 * 调拨路线（镜像 `schema.prisma` 的 `StockTransferRoute`）。
 *
 * `EVENT_TO_WAREHOUSE` 是 Phase 7 新增的第 4 个值（A-P7-07）：展会结算时选「回仓」会生成一条
 * 展→仓的子调拨单 —— 库存搬运必须有单据，否则凭证链在回仓这一步断掉、守恒也无从对账。
 * ⚠️ 它只能由 `POST /stock/transfers/:id/settle-destination` 生成，**不是用户可选路线**：
 * 前端的路线下拉必须过滤掉它（`apps/tenant` 的域，见任务书 §7 待裁决 ①）。
 */
export const STOCK_TRANSFER_ROUTES = [
    'WAREHOUSE_TO_SHOP',
    'WAREHOUSE_TO_EVENT',
    'EVENT_TO_EVENT',
    'EVENT_TO_WAREHOUSE',
    'TENANT_TO_TENANT',
];
export const TRANSFER_STATUSES = ['DRAFT', 'IN_TRANSIT', 'RECEIVED', 'CANCELLED'];
export const TRANSFER_DESTINATIONS = ['RETURN_TO_WAREHOUSE', 'CARRY_TO_NEXT_EVENT'];
export const RESERVATION_STATUSES = ['ACTIVE', 'CONSUMED', 'RELEASED'];
/**
 * 预占释放原因（镜像 `schema.prisma` 的 `ReleaseReason`）。
 *
 * `SHORT_MARKED` 是 Phase 5 新增的第四档：缺货标记按量释放（`POST /orders/:id/short`）。
 * 它与 `TIMEOUT` 的区别是「谁触发、为什么」—— `TIMEOUT` 是预占过期，`SHORT_MARKED`
 * 是店员在挑拣时发现货架没货。
 */
export const RELEASE_REASONS = ['CUSTOMER_CANCEL', 'STAFF_CANCEL', 'TIMEOUT', 'SHORT_MARKED'];
export const PRODUCT_STATUSES = ['DRAFT', 'ACTIVE', 'INACTIVE'];
export const PRODUCT_SOURCES = ['PLATFORM', 'TENANT'];
export const EVENT_SOURCES = ['PLATFORM', 'TENANT'];
export const EVENT_STATUSES = ['PREPARING', 'ONGOING', 'ENDED'];
//# sourceMappingURL=stock.js.map